import { ServerTransactionStatusEnum } from '@expane/data'
import { isThisCompletedPaymentTransaction } from './checks'

export const filterPaymentTransactions = <
  T extends { status: ServerTransactionStatusEnum; type: number },
>(
  transactions: T[],
): T[] => transactions.filter(transaction => isThisCompletedPaymentTransaction(transaction))
